import React from 'react';
import BottomXAxis from './BottomXAxis';
import LeftYAxis from './LeftYAxis';
import RightYAxis from './RightYAxis';
import LineChartToolTip from './LineChart/LineChartToolTip';
import LinePath from './LineChart/LinePath';
import AreaPaths from './AreaChart/AreaPaths';
import AreaChartToolTip from './AreaChart/AreaChartToolTip';
import VerticalBars from './BarChart/VerticalBars';

import * as d3 from '../../libraries/d3';
import DateHelper from '../DateHelper/DateHelper';

export default class ChartDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      xDateAccessor: this.props.xAxisDetail ? d => DateHelper.parse( d[this.props.xAxisDetail.data_column_name], this.props.dateFormat) : null,
      xAccessor: this.props.xAxisDetail ? d => d[this.props.xAxisDetail.data_column_name] : null,
      yAccessor: d => d[this.props.yAxisDetail.data_column_name],
      xDateScale: this.props.xAxisDetail ? d3.scaleTime().domain(d3.extent(this.props.data, (d) => DateHelper.parseDate(d[this.props.xAxisDetail.data_column_name], this.props.date_format))).nice().range([0, this.props.dimensions().boundedWidth]) : null,
      bandScale: d3.scaleBand().domain(this.props.data.map(d => d[this.props.xAxisDetail ? this.props.xAxisDetail.data_column_name : this.props.yAxisDetail.data_column_name])).range([0, this.props.dimensions().boundedWidth]).padding(0.2),
      yLineScale: this.props.yMaxMinDetailndValue ? d3.scaleLinear().domain([this.props.yMaxMinDetailndValue.min, this.props.yMaxMinDetailndValue.max]).nice().range([this.props.dimensions().boundedHeight, 0]) : null,
      xLineScale: this.props.xMaxMinDetailndValue ? d3.scaleLinear().domain([this.props.xMaxMinDetailndValue.max, 0]).range([this.props.dimensions().boundedWidth, 0]).nice() : null,
      yPercentScale: d3.scaleLinear().domain([0, 100]).nice().range([this.props.dimensions().boundedHeight, 0]),
      svg: () => d3.select(`#${this.props.report_details.chart_type.name}-${this.props.report_details.id}`),
      bounds: () => d3.select(`#bounds-${this.props.report_details.id}`),
    };
  };

  componentDidMount() {
    this.state.svg()
      .attr("viewBox", `0 0 ${this.props.dimensions().width} ${this.props.dimensions().height}`)
    this.state.bounds()
      .style('transform', `translate(${this.props.dimensions().margin.left}px, ${this.props.dimensions().margin.top}px)`);
  };

  render() {
    return (
      <g id={`bounds-${this.props.report_details.id}`} className='bounds-line-chart'>
        {this.renderChartDetails()}
      </g>
    );
  };

  renderChartDetails(){
    switch (true) {
      case this.props.report_details.chart_type.name === 'line_chart':
        return this.renderLineChartDetails();
      case this.props.report_details.chart_type.name === 'dual_axis_line_chart':
        return this.renderDualAxisLineChartDetails();
      case this.props.report_details.chart_type.name === 'area_chart':
        return this.renderAreaChartDetails();
      case this.props.report_details.chart_type.name === 'vertical_bar_chart':
        return this.renderVerticalBarChartDetails();
      case this.props.report_details.chart_type.name === 'horizontal_bar_chart':
        return this.renderHorizontalBarChartDetails();
    };
  };

  ////////// Line Chart /////////

  renderLineChartDetails() {
    return (
      [
        this.renderLines(this.props.yAxisDetails, this.props.yMaxMinDetailndValue),
        <BottomXAxis
          key={`BottomXAxis-${this.props.report_details.id}`}
          data={this.props.data}
          xAxisDetail={this.props.xAxisDetail}
          xScale={this.state.xDateScale}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          date_format={this.props.date_format}
          yDataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          chartType="LineChart"
        />
        ,
        <LeftYAxis
          key={`LeftYAxis-${this.props.report_details.id}`}
          data={this.props.data}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          yAxisDetails={this.props.yAxisDetails}
          dataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          chartType="LineChart"
        />
        ,
        <LineChartToolTip
          key={`LineChartToolTip-${this.props.report_details.id}`}
          data={this.props.data}
          xDateAccessor={this.state.xDateAccessor}
          xAxisDetail={this.props.xAxisDetail}
          xScale={this.state.xDateScale}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          yAxisDetails={this.props.yAxisDetails}
          onClickToolTip={this.props.onClickToolTip}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          yDataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          date_format={this.props.date_format}
          includeYOY={this.props.includeYOY}
          hiddenDetails={this.props.hiddenDetails}
        />
      ]
    );
  };

  renderLines(lineDetails, minMax) {
    return (
      lineDetails.map((detail, idx) => {
        return (
          <LinePath
            key={detail.data_column_name + idx}
            data={this.props.data}
            detail={detail}
            xDateAccessor={this.state.xDateAccessor}
            xScale={this.state.xDateScale}
            yScale={lineDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
            bounds={this.state.bounds}
            yMaxMinDetailndValue={minMax}
            xAxisDetail={this.props.xAxisDetail}
            dimensions={this.props.dimensions}
            date_format={this.props.date_format}
            hiddenDetails={this.props.hiddenDetails}
          />
        );
      })
    );
  };

  ////////// Dual Axis Line Chart /////////

  renderDualAxisLineChartDetails() {
    return (
      [
        this.renderLines(this.props.yAxisDetails, this.props.yMaxMinDetailndValue),
        this.renderLines(this.props.secondYAxisDetails, this.props.secondYMaxMinDetailndValue),
        <BottomXAxis
          key={`BottomXAxis-${this.props.report_details.id}`}
          data={this.props.data}
          xAxisDetail={this.props.xAxisDetail}
          xScale={this.state.xDateScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          date_format={this.props.date_format}
          yDataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          chartType="DualAxisLineChart"
        />
        ,
        <LeftYAxis
          key={`LeftYAxis-${this.props.report_details.id}`}
          data={this.props.data}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          yAxisDetails={this.props.yAxisDetails}
          dataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          controlTicks={true}
          chartType="DualAxisLineChart"
        />
        ,
        <RightYAxis
          key={`RightYAxis-${this.props.report_details.id}`}
          data={this.props.data}
          yScale={this.props.secondYAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          yMaxMinDetailndValue={this.props.secondYMaxMinDetailndValue}
          yAxisDetails={this.props.yAxisDetails}
          dataType={this.props.secondYAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          controlTicks={true}
          chartType="DualAxisLineChart"
        />
        ,
        <LineChartToolTip
          key={`LineChartToolTip-${this.props.report_details.id}`}
          data={this.props.data}
          xDateAccessor={this.state.xDateAccessor}
          xAxisDetail={this.props.xAxisDetail}
          xScale={this.state.xDateScale}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          secondYScale={this.props.secondYAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          yAxisDetails={this.props.yAxisDetails.concat(this.props.secondYAxisDetails)}
          onClickToolTip={this.props.onClickToolTip}
          includeYOY={this.props.includeYOY}
        />,
      ]
    );
  };


  //////////// Area Chart //////////

  renderAreaChartDetails() {
    return (
      [
        <AreaPaths
          key={`AreaPaths-${this.props.report_details.id}`}
          data={this.props.data}
          bounds={this.state.bounds}
          dimensions={this.props.dimensions}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          yAxisDetails={this.props.yAxisDetails}
          xAxisDetail={this.props.xAxisDetail}
          xScale={this.state.xDateScale}
          xDateAccessor={this.state.xDateAccessor}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          dataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
        />,
        <BottomXAxis
          key={`BottomXAxis-${this.props.report_details.id}`}
          data={this.props.data}
          xAxisDetail={this.props.xAxisDetail}
          xScale={this.state.xDateScale}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          date_format={this.props.date_format}
          yDataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          chartType="AreaChart"
        />
        ,
        <LeftYAxis
          key={`LeftYAxis-${this.props.report_details.id}`}
          data={this.props.data}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          yAxisDetails={this.props.yAxisDetails}
          dataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          chartType="AreaChart"
        />
        ,
        <AreaChartToolTip
          key={`AreaChartToolTip-${this.props.report_details.id}`}
          data={this.props.data}
          xDateAccessor={this.state.xDateAccessor}
          xAxisDetail={this.props.xAxisDetail}
          xScale={this.state.xDateScale}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          yAxisDetails={this.props.yAxisDetails}
          date_format={this.props.date_format}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          removedDataDetails={this.props.removedDataDetails}
          onClickToolTip={this.props.onClickToolTip}
          dataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
        />
      ]
    );
  };


  //////////// Vertical Bar Chart //////////

  renderVerticalBarChartDetails() {
    return (
      [
        this.renderVerticalBarChartBars()
        ,
        <BottomXAxis
          key={`BottomXAxis-${this.props.report_details.id}`}
          data={this.props.data}
          xScale={this.state.bandScale}
          xAxisDetail={this.props.xAxisDetail}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          tickFormat={'character'}
          yDataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          chartType="VerticalBar"
        />
        ,
        <LeftYAxis
          key={`LeftYAxis-${this.props.report_details.id}`}
          data={this.props.data}
          yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
          yAxisDetails={this.props.yAxisDetails}
          dataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          chartType="VerticalBar"
        />
      ]
    );
  };

  renderVerticalBarChartBars() {
    return (
      this.props.yAxisDetails.map((detail, idx) => {
        return (
          <VerticalBars
            key={detail.data_column_name + idx}
            report_details={this.props.report_details}
            data={this.props.data}
            xScale={this.state.bandScale}
            yScale={this.props.yAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.yLineScale}
            yDataDetail={detail}
            dimensions={this.props.dimensions}
            bounds={this.state.bounds}
            xAxisDetail={this.props.xAxisDetail}
            yAxisDetails={this.props.yAxisDetails}
            idx={idx}
            yMaxMinDetailndValue={this.props.yMaxMinDetailndValue}
            onClickToolTip={this.props.onClickToolTip}
            dataType={this.props.yAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.yAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
          />
        );
      })
    );
  };


  //////////// Horizontal Bar Chart //////////

  renderHorizontalBarChartDetails() {
    return (
      [
        <HorizontalBarChartYAxis
          key={`LeftYAxis-${this.props.report_details.id}`}
          data={this.props.data}
          yScale={this.state.bandScale}
          yAccessor={this.state.yAccessor}
          yAxisDetail={this.props.yAxisDetail}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
        />
        ,
        <HorizontalBarChartXAxis
          key={`BottomXAxis-${this.props.report_details.id}`}
          data={this.props.data}
          xScale={this.props.xAxisDetails[0].data_type === 'percent' ? this.state.yPercentScale : this.state.xLineScale}
          xAxisDetails={this.props.xAxisDetails}
          xMaxMinDetailndValue={this.props.xMaxMinDetailndValue}
          bounds={this.state.bounds}
          report_details={this.props.report_details}
          dimensions={this.props.dimensions}
          dataType={this.props.xAxisDetails[0].data_type === 'percent' ? 'percent' : this.props.xAxisDetails[0].data_type === 'currency' ? 'currency' : 'integer'}
        />
        ,
      ]
    );
  };

};
